export default "__VITE_ASSET__DC2xBsX6__"